let is_version_greater = (version, target) => {
    const versionParts = version.split('.').map(Number);
    const targetParts = target.split('.').map(Number);

    for (let i = 0; i < targetParts.length; i++) {
        if (versionParts[i] > targetParts[i]) return true;
        if (versionParts[i] < targetParts[i]) return false;
    }
    return false; // Versions are equal
}

export default is_version_greater;
